import React, { useContext, useEffect, useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import { Container, Row, Col } from 'react-bootstrap';
import PortfolioContext from '../../context/context';
import Title from '../Title/Title';
import LogoImg from '../Image/LogoImg';

const Companies = () => {
  const { companies } = useContext(PortfolioContext);

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);
  

  return (
    <section id="companies">
      <Container>
        <ScrollAnimation animateIn="fadeInUp" dalay={1000} duration={0.5} >
          <Title title="GLOBAL COMPANIES THAT PREVIOUSLY" titleSub="CHOSE HUNGARY" />
        </ScrollAnimation>
        <Row className="about-wrapper">
          <Col md={12} sm={12}>
              <div className="about-wrapper__info">
              <ScrollAnimation animateIn="fadeInLeft" dalay={1000} duration={0.5} >
                <p className="about-wrapper__info-text">
                    <i>Some of the global brands and manufacturers making products or parts of products in Hungary.</i>
                </p>
                <p className="companies-wrapper__info-text blue">
                    Audi, Mercedes-Benz, Samsung, Suzuki, Wizz-Air, Flextronics, Robert Bosch, Sanofi Aventis, Electrolux, Continental, Hankook, Teva, Lear Corporation, Denso, Opel, Valeo Auto Electric, Grundfos, BMW, Airbus, Doosan
                </p>
                <Row className="logos">
                    
                {companies.map((company) => {
                  const { title, img, id } = company;
                    return (
                      <Col className={title}>
                            <LogoImg alt={title} filename={img} />
                        </Col>
                    );
                })}
                </Row>
              </ScrollAnimation>
              <ScrollAnimation animateIn="fadeInLeft" dalay={1000} duration={0.5} >
                <div id="invest">
                  <h3>SUMMARY OF INVESTMENT OPPORTUNITIES AND&nbsp;THE ECONOMIC ENVIRONMENT IN HUNGARY</h3>
                  <p className="info-text">
                  You can find more information about investment opportunities, the Hungarian economic climate, taxation and administration, and investment support programmes (non-refundable grants) at the following link:
                  </p>
                  <p className="link-1"><a href="https://hipa.hu/main#publications">hipa.hu/main#publications</a></p>
                  <p><a href="https://hipa.hu">www.hipa.hu</a></p>
                </div>
              </ScrollAnimation>
              </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Companies;
